import { styled } from '@mui/material';

export const classes = {
  root: {
    overflow: 'hidden',
    paddingBottom: '56.25%',
    position: 'relative',
    height: 0,
    width: '100%',
    borderRadius: 4,
  },
  rootMobile: {
    aspectRatio: '8/7',
  },
};

export const Video = styled('video')({
  left: 0,
  top: 0,
  width: '100%',
  position: 'absolute',
});

export const VideoMobile = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});
